import { gql, useMutation } from "@apollo/client";
import { MutationUpdateDesignerApplicationArgs } from "../../__generated__/types";

// Normalize enum fields: convert empty strings to null/undefined before sending to GraphQL
const normalizeEnumFields = (data: any): any => {
  if (!data || typeof data !== 'object') {
    return data;
  }

  if (Array.isArray(data)) {
    return data.map(item => normalizeEnumFields(item));
  }

  const normalized: any = { ...data };

  // Handle application object
  if (normalized.application) {
    normalized.application = normalizeEnumFields(normalized.application);
  }

  // Normalize experience array enum fields
  if (normalized.experience && Array.isArray(normalized.experience)) {
    normalized.experience = normalized.experience.map((exp: any) => {
      const normalizedExp: any = { ...exp };
      if (normalizedExp.employmentType === '') {
        normalizedExp.employmentType = null;
      }
      if (normalizedExp.firmSize === '') {
        normalizedExp.firmSize = null;
      }
      return normalizedExp;
    });
  }

  // Normalize references array enum fields
  if (normalized.references && Array.isArray(normalized.references)) {
    normalized.references = normalized.references.map((ref: any) => {
      const normalizedRef: any = { ...ref };
      if (normalizedRef.type === '') {
        normalizedRef.type = null;
      }
      if (normalizedRef.ProjectType === '') {
        normalizedRef.ProjectType = null;
      }
      return normalizedRef;
    });
  }

  // Normalize businessGoals enum fields
  if (normalized.businessGoals && typeof normalized.businessGoals === 'object') {
    const goals: any = { ...normalized.businessGoals };
    if (goals.projectCapacity) {
      if (goals.projectCapacity.largeScale === '') {
        goals.projectCapacity.largeScale = null;
      }
      if (goals.projectCapacity.smallScale === '') {
        goals.projectCapacity.smallScale = null;
      }
    }
    normalized.businessGoals = goals;
  }

  // Normalize status enum field
  if (normalized.status === '') {
    normalized.status = null;
  }

  return normalized;
};

export const useUpdateMembershipApplicationMutation = () => {
  const UPDATE_MEMBERSHIP_APPLICATION_MUTATION = gql`
    mutation UpdateDesignerApplication(
      $application: UpdateDesignerApplicationInput!
    ) {
      updateDesignerApplication(application: $application)
    }
  `;

  const [updateApplicationMutation, { loading, error }] = useMutation(
    UPDATE_MEMBERSHIP_APPLICATION_MUTATION
  );

  const updateApplication = async (
    args: MutationUpdateDesignerApplicationArgs
  ) => {
    try {
      // Normalize enum fields before sending to GraphQL
      const normalizedArgs = normalizeEnumFields(args);
      
      console.log("🔄 Updating designer application with data:", normalizedArgs);
      const result = await updateApplicationMutation({
        variables: normalizedArgs,
      });
      console.log("✅ Application updated successfully:", result);
      return result?.data?.updateDesignerApplication;
    } catch (err: any) {
      console.error("❌ Error updating application:", err);
      console.error("❌ Error details:", {
        message: err?.message,
        graphQLErrors: err?.graphQLErrors,
        networkError: err?.networkError,
        extraInfo: err?.extraInfo
      });
      throw err;
    }
  };

  return { updateApplication, loading, error };
};
